import { ABOUT_URL, API_URL } from "../../lib/config";

/**
 * THE ABOUT PAGE, ON THE MARKETING SITE (owner, 2026-09-25; wave 88).
 *
 * It leaves the app, so it opens in a new tab and nothing in progress here is
 * lost. The address is a build parameter (`ABOUT_URL`), chosen per
 * environment. It sits beside Terms and Privacy wherever those two stand as a
 * row, and never inside a sentence of acceptance: nobody accepts anything by
 * reading it.
 */
export function AboutLink({ className = "" }: { className?: string }) {
  return (
    <a href={ABOUT_URL} target="_blank" rel="noopener" className={className}>
      About
    </a>
  );
}

/**
 * The two legal pages, served by the api's public surface (SSR, like door
 * pages), and About beside them. One quiet row, used by the root layout, the
 * sign-in screen and the intake consent — the three places docs/compliance.md
 * gap #1 names. The signed-in console's account row (`WrongAccount` in
 * `account.tsx`) spells out the same links itself and must carry the same set.
 *
 * NO REPRESENTATIVE LINK (owner, 2026-10-08). The representative's details are
 * required in the privacy notice (GDPR Art. 13) and publicly accessible (DSA
 * Art. 13(4)), not in a footer: Privacy §14 links /legal/representative and
 * Terms §14.6 names the DSA representative, which satisfies both.
 */
export function LegalLinks({ className = "" }: { className?: string }) {
  return (
    <p className={`text-xs text-fainter ${className}`}>
      <a
        href={`${API_URL}/terms`}
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-4 transition-colors hover:text-muted"
      >
        Terms
      </a>
      <span aria-hidden="true"> · </span>
      <a
        href={`${API_URL}/privacy`}
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-4 transition-colors hover:text-muted"
      >
        Privacy
      </a>
      <span aria-hidden="true"> · </span>
      <AboutLink className="underline underline-offset-4 transition-colors hover:text-muted" />
    </p>
  );
}
